<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="4" class="pt-0">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar color"
                    hide-details
                    solo
                    dense
                    class="wost-text-input"
                ></v-text-field>
            </v-col>
            <v-col cols="8" class="pt-0">
                <v-btn 
                    @click="handleViewCreate" 
                    rised 
                    color="indigo" 
                    dark
                    class="float-right wost-btn-new" 
                    v-if="verifyPermission('crear_colores')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo color
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="colors"
                        item-key="id"
                        :search="search"
                        height="68vh"
                        fixed-header
                        v-if="verifyPermission('listar_colores')"
                    >

                        <template v-slot:item.name="{item}">
                            {{ item.name | lowercase }}
                        </template>

                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <a href="#" 
                                    title="Editar" 
                                    class="btn-actions btn-edit" 
                                    @click="handleEditColor(item)"
                                    v-if="verifyPermission('actualizar_colores')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                &nbsp;
                                <a v-if="item.status  === 'activo' && verifyPermission('inactivar_colores')" 
                                    href="#" 
                                    title="Inactivar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_colores')" 
                                    href="#" 
                                    title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                            </div>
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <create-update ref="createUpdate"></create-update>
    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import CreateUpdate from '../../components/colors/CreateUpdate';

export default {
    name: 'Colors',
    components: {
        CreateUpdate
    },
    data () {
        return {
            search: null,
            headers: [
                { text: 'Nombre', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', align: 'end' }
            ],
        }
    },
    computed: {
        ...mapState('colors', [
            'colors',
            'color_response'
        ])
    },
    methods: {
        ...mapActions('colors', [
            'getColors',
            'change_status'
        ]),
        handleViewCreate () {
            this.$refs.createUpdate.show('Registrar nuevo color', 'create');
        },
        handleEditColor (color) {
            let formData = Object.assign({}, color);
            this.$refs.createUpdate.show('Actualizar color', 'update', formData);
        },
        changeStatus (color, status) {
            this.$swal({
                title: "¿Desea confirmar?",
                text: "Confirma que desea " + status + " el color",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
            }).then( async (result) => {
                if(result.value){
                    if(result.value === true){
                        await this.change_status(color);
                        if (this.color_response == 'error') {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                title: 'ACTUALIZACION DE COLOR',
                                text: 'Ocurrió un error al cambiar estado de color.'
                            });
                        } else {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'ACTUALIZACION DE COLOR',
                                text: 'El estado de color fue actualizado de forma correcta.'
                            });
                        }
                    }
                }                    
            })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created () {
        this.getColors();
    }
}
</script>

<style scoped>

</style>